import { SafeArea, StatusbarStyle } from 'capacitor-plugin-safe-area';
import { Capacitor } from '@capacitor/core';

/**
 * Définit le style de la barre de statut sur Android et iOS
 * @param isDarkBackground - true si le fond est sombre (texte blanc), false si le fond est clair (texte noir)
 */
export const setStatusBarStyle = async (isDarkBackground: boolean) => {
    if (!Capacitor.isNativePlatform()) {
        return;
    }
    
    try {
        await SafeArea.setImmersiveNavigationBar({
            statusBarStyle: isDarkBackground ? StatusbarStyle.Light : StatusbarStyle.Dark
        });
    } catch (error) {
        console.error('Error setting status bar style:', error);
    }
};

/**
 * Définit la couleur de fond de la safe area
 * @param color - Couleur CSS valide (hex, rgb, rgba, etc.)
 */
export const setSafeAreaBackgroundColor = (color: string) => {
    document.documentElement.style.setProperty('--safe-area-bg-color', color);
};
